export const INITIAL_PRODUCT_REQUEST = "INITIAL_PRODUCT_REQUEST";
export const FINAL_PRODUCT_REQUEST = "FINAL_PRODUCT_REQUEST";

export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS";
export const FETCH_PRODUCT_ERROR = "FETCH_PRODUCT_ERROR";

export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const SAVE_PRODUCT_SUCCESS = "SAVE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_PRICES_LOCALLY = "UPDATE_PRODUCT_PRICES_LOCALLY";
